import swal from 'sweetalert2'
var statusOpening = false
var isShow = false
export const Loading = (isNotDelay = false, text= null) => {
  if(isNotDelay){
    swal({
      titleText:(text) ? "Loading...":null,
      text: (text) ? text:"Loading..."
    }).then(res =>{
      if(res.dismiss === "overlay"){
        statusOpening = false
      }
    });
    swal.showLoading();
    statusOpening = true
  }else{
    isShow = true
    if(!statusOpening){
      setTimeout(()=>{
        if(isShow){
          swal({ 
            titleText:(text) ? "Loading...":null,
            text: (text) ? text : "Loading..."
          }).then(res =>{
            if(res.dismiss === "overlay"){
              statusOpening = false
            }
          });
          swal.showLoading();
          statusOpening = true
        }
      },500)
    }
  }
  
}
export const LoadingClose = () => {
  swal.close();
  statusOpening = false
  isShow = false
}
